// Backup Project for a Penyedia (Simulasi Pluto v4 backup on the Generator
// Dokumen page): the paket projects with their checklist and every work tool
// (Reviu Persyaratan, Kalkulator RAB, Quality Gate, Pengendalian Kontrak),
// read through the existing API and saved as one .json file on the device.
// A tool that cannot be read is left null; the backup never fails on it.
import * as API from "../api";
import * as Work from "../project/work/api";

export interface PaketBackupEntry {
  project: API.Project;
  checklist: API.ChecklistGroup[] | null;
  persyaratan: Work.RequirementMatrix | null;
  rab: Work.Rab | null;
  qualityGate: Work.Quality | null;
  kontrak: Work.ContractView | null;
}

export interface PaketBackup {
  app: "Pluto";
  kind: "backup_project_penyedia";
  exportedAt: string;
  projects: PaketBackupEntry[];
}

/** "Backup_Project_Penyedia_Jalan_Desa_2026-10-15.json"; without a name, every paket. */
export function paketBackupFileName(name: string | null, exportedAt: string): string {
  const slug = (name ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^A-Za-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 60);
  return `Backup_Project_Penyedia_${slug || "semua_paket"}_${exportedAt.slice(0, 10)}.json`;
}

async function entryOf(project: API.Project): Promise<PaketBackupEntry> {
  const id = project.id;
  const [detail, persyaratan, rab, qualityGate, kontrak] = await Promise.all([
    API.getProject(id).catch(() => null),
    Work.getRequirements(id).catch(() => null),
    Work.getRab(id).catch(() => null),
    Work.getQuality(id).catch(() => null),
    Work.getContract(id).catch(() => null),
  ]);
  return { project: detail?.project ?? project, checklist: detail?.checklist ?? null, persyaratan, rab, qualityGate, kontrak };
}

/** Builds the backup of `projects` (paket projects only) and hands it to the browser as a download. */
export async function downloadPaketBackup(projects: API.Project[], now: Date = new Date()): Promise<PaketBackup> {
  const paket = projects.filter((p) => p.kind === "paket");
  const backup: PaketBackup = { app: "Pluto", kind: "backup_project_penyedia", exportedAt: now.toISOString(), projects: await Promise.all(paket.map(entryOf)) };
  if (typeof URL.createObjectURL !== "function") return backup;
  const blob = new Blob([JSON.stringify(backup, null, 2)], { type: "application/json;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = paketBackupFileName(paket.length === 1 ? (paket[0]!.paketName?.trim() || paket[0]!.name) : null, backup.exportedAt);
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return backup;
}
